"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var TextArea_st_css_1 = require("./TextArea.st.css");
var dataHooks_1 = require("./dataHooks");
var Error_1 = require("wix-ui-icons-common/on-stage/Error");
var dataKeys_1 = require("./dataKeys");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
var TextAreaEnums_1 = require("./TextAreaEnums");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var IconTooltip_1 = require("../IconTooltip");
var deprecationLog_1 = require("../../common/deprecationLog");
var uniqueId = require('lodash/uniqueId');
/** TextArea component */
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this._rootRef = React.createRef();
        _this.state = {
            focused: false,
            isErrorTooltipShown: false,
        };
        _this._getErrorIconTooltip = function () {
            var isErrorTooltipShown = _this.state.isErrorTooltipShown;
            var _a = _this.props, errorDescription = _a.errorDescription, errorTooltipPlacement = _a.errorTooltipPlacement, errorTooltipMaxWidth = _a.errorTooltipMaxWidth;
            return (React.createElement(IconTooltip_1.IconTooltip, { "data-hook": dataHooks_1.ERROR_ICON_DATA_HOOK, className: TextArea_st_css_1.st(TextArea_st_css_1.classes.iconTooltip), message: errorDescription, icon: React.createElement(Error_1.default, { className: TextArea_st_css_1.classes.errorIcon }), tooltipId: _this._errorMessageId, tooltipSkin: TooltipEnums_1.TooltipSkin.Error, showTooltip: isErrorTooltipShown, onClick: _this._onErrorButtonClick, onBlur: _this._onClickOutsideOrBlur, onClickOutside: _this._onClickOutsideOrBlur, tooltipProps: {
                    placement: errorTooltipPlacement,
                    appendTo: 'scrollParent',
                    moveBy: { x: 5, y: 0 },
                    maxWidth: errorTooltipMaxWidth,
                } }));
        };
        _this.showErrorTooltip = function () {
            _this._toggleTooltip(true);
        };
        _this.hideErrorTooltip = function () {
            _this._toggleTooltip(false);
        };
        _this._onFocus = function () {
            _this.setState({ focused: true });
            if (_this._rootRef.current &&
                _this._rootRef.current.contains(document.activeElement)) {
                _this._toggleTooltip(true);
            }
        };
        _this._toggleTooltip = function (showTooltip) {
            _this.setState({ isErrorTooltipShown: showTooltip });
        };
        _this._onErrorButtonClick = function () {
            var isErrorTooltipShown = _this.state.isErrorTooltipShown;
            _this._toggleTooltip(!isErrorTooltipShown);
        };
        _this._onClickOutsideOrBlur = function () {
            if (_this._rootRef.current &&
                !_this._rootRef.current.contains(document.activeElement)) {
                _this._toggleTooltip(false);
            }
        };
        _this._onBlur = function () {
            _this.props.onBlur && _this.props.onBlur();
            _this.setState({ focused: false });
        };
        _this.labelForId = uniqueId('label-for-id_');
        _this._errorMessageId = uniqueId('error-message');
        if (props.withFocusRing) {
            deprecationLog_1.deprecationLog('TextArea', 'The prop "withFocusRing" is deprecated and will be removed in the next major release.');
        }
        return _this;
    }
    TextArea.prototype._getDataAttributes = function () {
        var _a;
        var _b = this.props, disabled = _b.disabled, success = _b.success, theme = _b.theme, error = _b.error;
        var focused = this.state.focused;
        return _a = {},
            _a[dataKeys_1.TEXT_AREA_DISABLED] = disabled,
            _a[dataKeys_1.TEXT_AREA_THEME] = theme,
            _a[dataKeys_1.TEXT_AREA_ERROR] = error,
            _a[dataKeys_1.TEXT_AREA_SUCCESS] = success,
            _a[dataKeys_1.TEXT_AREA_FOCUS] = focused,
            _a;
    };
    TextArea.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, theme = _a.theme, error = _a.error, success = _a.success, disabled = _a.disabled, label = _a.label, onChange = _a.onChange, onBlur = _a.onBlur, placeholder = _a.placeholder, errorDescription = _a.errorDescription, autoFocus = _a.autoFocus, className = _a.className, maxLength = _a.maxLength, showCharCount = _a.showCharCount, ariaDescribedBy = _a["aria-describedby"];
        var dataObject = this._getDataAttributes();
        var showErrorIcon = error && errorDescription;
        var isMobile = this.context.mobile;
        var hasFocusRing = !isMobile && this.state.focused;
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var rtl = _a.rtl;
            return (React.createElement("div", __assign({ className: TextArea_st_css_1.st(TextArea_st_css_1.classes.root, {
                    error: error,
                    rtl: rtl,
                    errorDescription: !!errorDescription,
                    theme: theme,
                    success: success,
                    disabled: disabled,
                }, className) }, dataObject, { "data-hook": _this.props['data-hook'], ref: _this._rootRef }),
                label && (React.createElement("label", { htmlFor: _this.props.id || _this.labelForId, "data-hook": dataHooks_1.LABEL_DATA_HOOK, className: TextArea_st_css_1.st(TextArea_st_css_1.classes.label) }, label)),
                React.createElement("div", { className: TextArea_st_css_1.st(TextArea_st_css_1.classes.textAreaWrapper, hasFocusRing ? TextArea_st_css_1.classes.focused : '') },
                    React.createElement("textarea", { value: value, disabled: disabled, onChange: function (e) {
                            if (!disabled) {
                                onChange(e);
                            }
                        }, id: _this.props.id || _this.labelForId, maxLength: maxLength, autoFocus: autoFocus, onFocus: _this._onFocus, onBlur: _this._onBlur, placeholder: placeholder, className: classnames_1.default(TextArea_st_css_1.classes.textArea, 'has-custom-focus'), "data-hook": dataHooks_1.TEXT_AREA_DATA_HOOK, "aria-label": _this.props.ariaLabel, "aria-describedby": ((ariaDescribedBy || '') + " " + (errorDescription ? _this._errorMessageId : '')).trim(), "aria-invalid": error }),
                    showErrorIcon && (React.createElement("div", { "data-hook": dataHooks_1.TEXT_AREA_ERROR_DATA_HOOK, className: TextArea_st_css_1.classes.errorIconWrapper }, _this._getErrorIconTooltip()))),
                maxLength && showCharCount && (React.createElement("div", { "data-hook": dataHooks_1.CHAR_COUNTER_DATA_HOOK, className: TextArea_st_css_1.classes.charCount }, value.length + "/" + maxLength))));
        }));
    };
    TextArea.displayName = 'TextArea';
    TextArea.defaultProps = {
        error: false,
        success: false,
        disabled: false,
        placeholder: '',
        errorDescription: '',
        theme: TextAreaEnums_1.TextAreaTheme.Box,
        withFocusRing: false,
        showCharCount: false,
        errorTooltipPlacement: 'top-end',
    };
    return TextArea;
}(React.Component));
exports.TextArea = TextArea;
//# sourceMappingURL=TextArea.js.map